import React from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import './About.css';

function About() {
  return (
    <section id="about" className="py-5">
      <Container>
        <h2 className="text-center mb-3">About Me</h2>
        <Row>
          <Col md={6}>
            <h3>Hi, I'm Nishant Chaudhary</h3>
            <p>
            A passionate full-stack web developer focused on building modern, responsive, and user-friendly web applications. I specialize in React.js, front-end development, and creating dynamic digital experiences with clean UI/UX design.
            <br/>
            I enjoy turning ideas into real-world solutions using technologies like React.js, Tailwind CSS, Node.js, Express.js, and MongoDB. From e-commerce platforms to management systems, I love developing projects that solve practical problems and improve user experience.
            <br/>
            I'm continuously learning new technologies, improving my development skills, and exploring innovative ways to build scalable and efficient applications. My goal is to create impactful software solutions while growing as a professional developer in the tech industry.
            </p>
            <Button href="#contact" variant="primary">Get in Touch</Button>
          </Col>
          <Col md={6}>
            <div className="about-video-container">
              <video width="100%" height="auto" controls autoPlay muted>
                <source src="/assets/videos/coding-demo.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;
